import produce from 'immer';
import { SET_PAGEFOOTER_INFO } from '../../actions/actionTypes';

export const defaultState = {
    currentBranch: null,
};

const pageFooter = produce((draft, action) => {
    switch (action?.type) {
        case SET_PAGEFOOTER_INFO:
            draft.currentBranch = action.currentBranch;
            return draft;
        default:
            return draft;
    }
}, defaultState);

export default pageFooter;
